import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BUCKET_FILTER, LINK_FILTER, MULTISELECT_FILTER, RANGE_FILTER, } from '@as-react/common-types';
import { CaretDownIcon } from '@yonderland/andes-icons';
import { Box, CollapsibleContent, CollapsibleToggle, Divider, Icon, IconButton, Stack, useCollapsible, } from '@yonderland/andes-react';
import { generateTestId } from '../../../util/TestUtil';
import { FilterItemContentBucketFilter } from './filters-item/FilterItemContentBucketFilter';
import { FilterItemContentColorFilter } from './filters-item/FilterItemContentColorFilter';
import { FilterItemContentLinkFilter } from './filters-item/FilterItemContentLinkFilter';
import { FilterItemContentMultiSelect } from './filters-item/FilterItemContentMultiSelect';
import { FilterItemContentRangeFilter } from './filters-item/FilterItemContentRangeFilter';
import { FiltersItemHeader } from './FiltersItemHeader';
var TestMatchOptions;
(function (TestMatchOptions) {
    TestMatchOptions["EXACT"] = "exact";
    TestMatchOptions["REGEX"] = "regex";
})(TestMatchOptions || (TestMatchOptions = {}));
const dynamicFilterSelectors = [
    {
        test: [
            {
                key: 'type',
                value: MULTISELECT_FILTER,
                matching: TestMatchOptions.EXACT,
            },
            {
                key: 'filterOn',
                value: '^(?!.*colour).*$',
                matching: TestMatchOptions.REGEX,
            },
        ],
        component: FilterItemContentMultiSelect,
    },
    {
        test: [
            {
                key: 'type',
                value: MULTISELECT_FILTER,
                matching: TestMatchOptions.EXACT,
            },
            {
                key: 'filterOn',
                value: /^(.*colour).*$/g,
                matching: TestMatchOptions.REGEX,
            },
        ],
        component: FilterItemContentColorFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: RANGE_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentRangeFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: BUCKET_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentBucketFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: LINK_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentLinkFilter,
    },
];
const dynamicFilterTesterFunction = (dynamicComponentTester, filterObj) => {
    switch (dynamicComponentTester.matching) {
        case TestMatchOptions.REGEX:
            return new RegExp(dynamicComponentTester.value).exec(String(filterObj[dynamicComponentTester.key])) !== null;
        case TestMatchOptions.EXACT:
            return filterObj[dynamicComponentTester.key] === dynamicComponentTester.value;
        default:
            return false;
    }
};
const dynamicFilterFunction = (dynamicComponentChecker, filterObj) => dynamicComponentChecker.test.every(tester => dynamicFilterTesterFunction(tester, filterObj));
export const FiltersItem = ({ desktop, filter, onFilterItemChange, isCollapsedByDefault, tooltip, }) => {
    const { toggleProps, contentProps, iconClasses } = useCollapsible({
        id: `filter-item-collapse-${filter.name.replace(/ /g, '_').toLowerCase()}`,
        open: !isCollapsedByDefault,
    });
    const testId = `filter-${filter.name.replace(/ /g, '_').toLowerCase()}`;
    const DynamicFilter = dynamicFilterSelectors.find(dynamicFilterSelector => dynamicFilterFunction(dynamicFilterSelector, filter));
    if (DynamicFilter) {
        const DynamicComponent = DynamicFilter.component;
        return desktop ? (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsxs(Box, { "data-testid": testId, children: [_jsx(CollapsibleToggle, Object.assign({}, toggleProps, { className: "a:cursor-pointer", tag: "div", children: _jsxs(Stack, { testId: generateTestId({ testId, suffix: 'toggle' }), wrap: "nowrap", justify: "between", align: "center", children: [_jsx(FiltersItemHeader, { filter: filter, tooltip: tooltip }), _jsx(Box, { flex: { shrink: 0, grow: 0 }, paddingBlock: "4", children: _jsx(IconButton, { theme: "neutral", variant: "plain", size: "sm", children: _jsx(Icon, { source: CaretDownIcon, size: "xs", className: iconClasses.replace('a:ml-2', '') }) }) })] }) })), _jsx(CollapsibleContent, Object.assign({}, contentProps, { children: _jsx(Box, { testId: generateTestId({ testId, suffix: 'content' }), overflow: "hidden", paddingBlockEnd: "4", children: _jsx(DynamicComponent, { toggleFilterOptions: filter.toggleFilterOptions, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, isCollapsedByDefault: Boolean(isCollapsedByDefault) }) }) }))] })] })) : (_jsx(DynamicComponent, { toggleFilterOptions: false, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, isCollapsedByDefault: Boolean(isCollapsedByDefault) }));
    }
    return null;
};
